angular.module('umConfig', [])
    .constant('moduleConfigConstant', {
        submission: {
            showHeader: true,
            routes: {
                'extension': {
                    url: '/submission/:submissionId/extensions/:extension',
                    views: {
                        'header': {
                            templateUrl: '/common/header/appHeader.tpl.html',
                            controller: 'appHeaderController'
                        },
                        'content': {
                            templateUrl: '/dynamicGrid.tpl.html',
                            controller: 'dynamicGridController'
                        }
                    }
                },
                'submission': {
                    url: '/submission/:submissionId',
                    views: {
                        'header': {
                            templateUrl: '/common/header/appHeader.tpl.html',
                            controller: 'appHeaderController'
                        },
                        'content': {
                            templateUrl: '/submission.tpl.html',
                            controller: 'submissionController'
                        }
                    }
                },
                'submission.print':{
                    url: '/print/:formId',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/print/printOverview.tpl.html',
                            controller: 'printOverviewController'
                        }
                    },
                    params: {
                        print: true,
                        formSummaryInstanceId: null,
                        ownerUriId: null
                    }
                },
                'submission.printCollaboration': {
                    url: '/print/collaboration/:collabType',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/print/printCollaboration.tpl.html',
                            controller: 'printOverviewController'
                        }
                    },
                    params: {
                        print: true,
                        formSummaryInstanceId: null,
                        ownerUriId: null
                    }
                },
                'submission.printFormSummaryGridDetail': {
                    url: '/print/:formId/detail/:ownerUriId/:formSummaryInstanceId',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/print/printOverview.tpl.html',
                            controller: 'printOverviewController'
                        }
                    },
                    params: {
                        print: true
                    }
                },
                'submission.accountSubmissionsGrid': {
                    url: '/account/:accountId/list',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/accountSubmissionsGrid/accountSubmissions.tpl.html',
                            controller: 'accountSubmissionsController'
                        }
                    }
                },
                'submission.default': {
                    url: '/default',
                    views: {
                        'mainContent': {
                            templateUrl: '/form/submissionFormViewer.tpl.html',
                            controller: 'submissionFormViewerController'
                        }
                    }
                },
                'submission.collab': {
                    url: '/collab/:collabType/:collabId',
                    views: {
                        'mainContent': {
                            templateUrl: '/form/submissionFormViewer.tpl.html',
                            controller: 'submissionFormViewerController'
                        }
                    }
                },
                'submission.form': {
                    url: '/form/:formId',
                    views: {
                        'mainContent': {
                            templateUrl: '/form/submissionFormViewer.tpl.html',
                            controller: 'submissionFormViewerController'
                        }
                    },
                    params: {
                        formId: {
                            value: null,
                            squash: true
                        }
                    }
                },
                'submission.formSummaryGridDetail': {
                    url: '/form/:formId/detail/:ownerUriId/:formSummaryInstanceId',
                    views: {
                        'mainContent': {
                            templateUrl: '/formViewer/component/formSummary/detail/formSummaryGridDetail.tpl.html',
                            controller: 'formSummaryGridDetailController'
                        }
                    },
                    resolve: {
                        /*@ngInject*/
                        effectiveDate: function (currentSubmissionModel) {
                            return {
                                get: function () {
                                    return currentSubmissionModel.getCurrentSubmission().effectiveDate;
                                }
                            };
                        },
                        /*@ngInject*/
                        currencyCode: function (currentSubmissionModel) {
                            return {
                                get: function () {
                                    return currentSubmissionModel.getCurrentSubmission().currencyCode;
                                }
                            };
                        },
                        printable: function () {
                            return {
                                get: function () {
                                    return true;
                                }
                            };
                        }
                    }
                },
                'submission.document': {
                    url: '/document/:attachmentId',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/document/document.tpl.html',
                            controller: 'documentController'
                        }
                    }
                },
                'submission.quote': {
                    url: '/quote/:quoteId',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/quoteSummaries/quoteSummaries.tpl.html',
                            controller: 'quoteSummariesController'
                        }
                    }

                },
                'submission.quotes': {
                    url: '/quotes',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/quoteSummaries/quoteSummaries.tpl.html',
                            controller: 'quoteSummariesController'
                        }
                    }

                },
                'submission.proposal': {
                    url: '/proposal/:proposalId',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/proposalSummary/proposalSummary.tpl.html',
                            controller: 'proposalSummaryController'
                        }
                    }
                },
                'submission.proposals': {
                    url: '/proposals',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/proposalSummaries/proposalSummaries.tpl.html',
                            controller: 'proposalSummariesController'
                        }
                    }
                },
                'submission.reports': {
                    url: '/reports',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/reportsSummary/reportsSummary.tpl.html',
                            controller: 'reportsSummaryController'
                        }
                    }

                },
                'submission.policies': {
                    url: '/policies',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/policiesSummaryGrid/policiesSummary.tpl.html',
                            controller: 'policiesSummaryController'
                        }
                    }

                },
                'submission.policy': {
                    url: '/policies/:policyId',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/policiesSummaryGrid/policiesSummary.tpl.html',
                            controller: 'policiesSummaryController'
                        }
                    }
                },
                'submission.externalContent': {
                    url: '/externalContent/:externalContentId',
                    views: {
                        'mainContent': {
                            templateUrl: '/content/externalContent/externalContent.tpl.html',
                            controller: 'externalContentController'
                        }
                    },
                    params: {
                        externalContentUrl: null,
                        externalContentPopoutUrl: null
                    }
                }
            }
        }
    });
